// src/components/FolderConfigurations.js

import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axiosInstance from '../utils/axios';
import { AgGridReact } from 'ag-grid-react';
import Modal from 'react-modal';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { Grid, TextField, Button, Select, MenuItem, FormControl, InputLabel } from '@mui/material';

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import './FolderConfigurations.css';
import AssayConfigurationWizard from './AssayConfigurationWizard';
import { ContactlessOutlined } from '@mui/icons-material';

const FolderConfigurations = () => {
  const { type } = useParams();
  const [folderConfigurations, setFolderConfigurations] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [assayModalIsOpen, setAssayConfigurationWizardIsOpen] = useState(false);
  const [croDetailsIsOpen, setCroDetailsIsOpen] = useState(false);
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);
  const [currentConfig, setCurrentConfig] = useState(null);
  const [assayWizardStepPosition, setAssayWizardStepPosition] = useState(0)
  const [newConfig, setNewConfig] = useState({
    approved_users: [],
    assay_name: '',
    config_directory: '',
    status: 'NEW',
    config_type: 'Assay',
    cro_contact: '',
    data_file_cro: '',
    data_file_program: '',
    labels: '',
    plugin: 'acas_assay',
    preprocessor: 'standard_preprocessor',
    validator: 'standard_validator',
    loader: 'standard_loader',
    point_of_contact_id: '',
    provider_organization_id: '',
    issue_program_id: '',
  });
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log("in useEffect2:" + type)

    fetchFolderConfigurations();
  }, []);

  const fetchFolderConfigurations = async () => {
    try {
      let url = 'issue_configurations/?status=ACTIVE'
      if (type != "") {
        url = url + '&config_type=' + type;
      }
      const response = await axiosInstance.get(url);
      setFolderConfigurations(response.data);
      console.dir("setFolderConfigurations:")
      console.dir(response.data)
    } catch (error) {
      setError('Error fetching folder configurations');
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewConfig((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const openModal = (config = null) => {

    console.dir("open model called with...")
    if (config == null) {
      setCurrentConfig(newConfig);
      console.dir(newConfig)
    } else {
      setCurrentConfig(config);
      console.dir(config)
    }

    if (type == "Assay") {
      setAssayConfigurationWizardIsOpen(true);
      setAssayWizardStepPosition(0);
    } else {
      setModalIsOpen(true);
    }
  };

  const closeAssayConfigurationWizard = () => {
    setAssayConfigurationWizardIsOpen(false);
    fetchFolderConfigurations();
  };

  const assayModalCompleted = () => {
    setAssayConfigurationWizardIsOpen(false);
    // setCroDetailsIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setCurrentConfig(null);
  };

  const openDeleteModal = (config) => {
    setCurrentConfig(config);
    setDeleteModalIsOpen(true);
  };

  const closeDeleteModal = () => {
    setDeleteModalIsOpen(false);
    setCurrentConfig(null);
  };

  const openCroDetailsModal = (config) => {
    setCurrentConfig(config);
    setCroDetailsIsOpen(true);
  };


  const closeCroDetailsModal = (config) => {
    setCroDetailsIsOpen(false);
    setCurrentConfig(null);
  };

  const reverseCroDetailsModal = (config) => {
    setAssayConfigurationWizardIsOpen(true);
    setCroDetailsIsOpen(false);
  };




  const handleCreateUpdateCRO = (config) => {
    setCroDetailsIsOpen(false);
    setCurrentConfig(null);
  };

  const onAssaySubmit = async (e, config) => {
    e.preventDefault();

    console.dir("Folder configurations onAssaySubmit")

    try {
      fetchFolderConfigurations();
      assayModalCompleted();
      console.dir("assayModalCompleted")
    } catch (error) {
      console.dir(error)
      setError('Error saving folder configuration');
    }
  }

  const handleCreateUpdate = async (e) => {
    e.preventDefault();
    try {
      if (currentConfig) {
        await axiosInstance.put(`issue_configurations/${currentConfig.id}/`, newConfig);
      } else {
        await axiosInstance.post('issue_configurations/', newConfig);
      }
      fetchFolderConfigurations();
      closeModal();
    } catch (error) {
      setError('Error saving folder configuration');
    }
  };
  const handleCreateUpdateWizard = async (e) => {
    e.preventDefault();
    try {
      // if (currentConfig) {
      //   await axiosInstance.put(`issue_configurations/${currentConfig.id}/`, newConfig);
      // } else {
      //   await axiosInstance.post('issue_configurations/', newConfig);
      // }
      // fetchFolderConfigurations();
      closeModal();
    } catch (error) {
      setError('Error saving folder configuration');
    }
  };

  const handleDelete = async () => {
    try {
      await axiosInstance.delete(`issue_configurations/${currentConfig.id}/`);
      fetchFolderConfigurations();
      closeDeleteModal();
    } catch (error) {
      setError('Error deleting folder configuration');
    }
  };

  const renderEditButton = (params) => (
    <button className="icon-button" onClick={() => openModal(params.data)}>
      <EditIcon />
    </button>
  );

  const renderDeleteButton = (params) => (
    <button className="icon-button" onClick={() => openDeleteModal(params.data)}>
      <DeleteIcon />
    </button>
  );

  const onRowDoubleClicked = (params) => {
    openModal(params.data);
  };

  const columns = [
    {
      headerName: "Actions",
      cellRenderer: (params) => (
        <>
          {renderEditButton(params)}
          {renderDeleteButton(params)}
        </>
      ),
      width: 100,
      cellStyle: { display: 'flex', alignItems: 'center', justifyContent: 'space-around' }
    },
    { headerName: "Directory", field: "config_directory", flex: 2 },
    // { headerName: "Status", field: "status", flex: 1 },
    // { headerName: "Assay Type", field: "config_type", flex: 1 },
    { headerName: "Program", field: "issue_program.name", flex: 1 },
    { headerName: "Assay Provider", field: "provider_organization.name", flex: 1 },
    { headerName: "Internal Contact", field: "point_of_contact.email", flex: 1 },
    // { headerName: "Labels", field: "labels", flex: 1 },
    // { headerName: "Plugin", field: "plugin", flex: 1 },
    // { headerName: "Preprocessor", field: "preprocessor", flex: 1 },
    // { headerName: "Validator", field: "validator", flex: 1 },
    // { headerName: "Loader", field: "loader", flex: 1 },
    // { headerName: "Primary Contact", field: "primary_contact", flex: 1 },
    // { headerName: "Last Updated", field: "last_updated", flex: 1 },
    // { headerName: "Creation Date", field: "creation_date", flex: 1 }
  ];

  return (
    <div className="folder-configurations-container">
      <h1>Manage {type} Configurations</h1>
      <button onClick={() => openModal(newConfig)} className="add-configuration-button">Add {type} Configuration</button>
      {error && <div className="error-message">{error}</div>}
      <div
        className="ag-theme-alpine"
        style={{
          height: '400px',
          width: '80%'
        }}
      >
        <AgGridReact
          rowData={folderConfigurations}
          columnDefs={columns}
          domLayout="autoHeight"
          onRowDoubleClicked={onRowDoubleClicked}
        />
      </div>

      <AssayConfigurationWizard
        inputConfig={currentConfig}
        open={assayModalIsOpen}
        onClose={closeAssayConfigurationWizard}
        onSubmit={onAssaySubmit}
        stepPosition={assayWizardStepPosition}
      />

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Generic Configuration Modal"
        className="modal"
        overlayClassName="overlay"
      >
      </Modal>
      <Modal
        isOpen={deleteModalIsOpen}
        onRequestClose={closeDeleteModal}
        contentLabel="Delete Confirmation"
        className="modal"
        overlayClassName="overlay"
      >
        <h2>Confirm Delete</h2>
        <p>Are you sure you want to delete the folder configuration "{currentConfig && currentConfig.config_directory}"?</p>
        <button onClick={handleDelete}>Yes, Delete</button>
        <button onClick={closeDeleteModal}>Cancel</button>
      </Modal>
    </div>
  );
};

export default FolderConfigurations;
